<template>
  <div class="welcome-background">
    <v-container>
      <v-row
        style="height:100vh"
        justify="center"
        align="center"
        class="mt-7 mt-xl-13 text-center"
      >
        <v-col cols="5" align-self="end" style="">
          <ButtonWithFrame to="About">About</ButtonWithFrame>
        </v-col>
        <v-col cols="2" align-self="end" style=""></v-col>
        <v-col cols="5" style="" align-self="end">
          <ButtonWithFrame to="Contact">Contact</ButtonWithFrame>
        </v-col>
        <v-col cols="12" align-self="center" class="mt-md-5 mt-xl-16">
          <div class="mt-xl-7">
            <ButtonWithFrame long to="Portfolio">Portfolio</ButtonWithFrame>
          </div>
        </v-col>
        <!-- </v-row> -->
      </v-row>
    </v-container>
  </div>
</template>

<script>
import ButtonWithFrame from '@/components/ButtonWithFrame.vue'
export default {
  components: {
    ButtonWithFrame
  },
  data() {
    return {}
  }
}
</script>

<style scoped>
.welcome-background {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: url('/images/virtue-landing.jpg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  color: #0505053b;
  /* background: black;
  mix-blend-mode: hue; */
  /* filter: blur(8px);
  -webkit-filter: blur(8px); */
}

.card-width {
  margin: 0 auto;
  max-width: 250px;
}
</style>
